import axios from 'axios';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
const service = axios.create({
    baseURL: "/manual_correction_group_composition", // url = base url + request url
    timeout: 3000000,
});
export default service;
